module.exports = __webpack_public_path__ + "img/lookbook_1_left.8bb5a566.png";